export enum RhythmView {
    RHYTHMS = 'rhythms',
    EXTRAS = 'extras',
    LEAD_12 = '12 lead'
}